import React from 'react'
import icons from './icons'

export default ({icon, ...props}) => {
    const Icon = icons[icon]

    return <Icon width={props.width || 30} height={props.height || 30} {...props} />
}
